module.exports = __webpack_public_path__ + "fc40a6ac40ffcd15d3ccf8b30b680c52.png";